import requestAction from '../../utils/requestAction';
import MassNotification from '../../models/MassNotification';

export const upsertMassNotification = (notification: MassNotification) =>
  requestAction('MASS_NOTIFICATION_UPSERT')(
    `massNotifications${notification.id ? `/${notification.id}` : ''}`,
    notification.id ? 'PUT' : 'POST',
    notification
  );
